import * as consts from './FloorplanConsts';
import { push } from 'react-router-redux';
import { savePosition } from '../app/AppActions';

export const setActiveSlide = (name) => {
    return (dispatch, getState) => {
        const visitedSlides = new Set(getState().floorplan.visitedSlides);

        if (name.length) {
            visitedSlides.add(name);
        }

        dispatch({
            type: consts.SET_ACTIVE_SLIDER,
            payload: {
                activeSlideName: name,
                visitedSlides
            }
        })
    }
}

export const changeStage = (value) => {
    return {
        type: consts.CHANGE_STAGE,
        payload: value
    }
}

export const setMapPosition = (x, y) => {
    return {
        type: consts.SET_MAP_POSITION,
        payload: {
            mapPosition: {
                x,
                y
            }
        }
    }
}

export const changeZoom = (value, content) => {
    return (dispatch, getState) => {
        const zoom = getState().floorplan.zoom;
        const minZoom = getState().floorplan.minZoom;
        const result = zoom + value > minZoom
            ? (zoom + value)
            : zoom;

        dispatch({
            type: consts.SET_ZOOM,
            payload: result
        });

        // center map regarding zoom
        if (zoom + value > minZoom) {
            const mapPosition = getState().floorplan.mapPosition;
            const horizontalTranslation = content.width * value / 2;
            const verticalTranslation = content.height * value / 2;

            const mapPositionX = mapPosition.x - horizontalTranslation;
            const mapPositionY = mapPosition.y - verticalTranslation;

            dispatch(setMapPosition(mapPositionX, mapPositionY));
        }
    }
}

export const setZoom = (value) => {
    return {
        type: consts.SET_ZOOM,
        payload: value
    }
}

export const toggleVisibility = () => {
    return dispatch => {
        dispatch({
            type: consts.TOGGLE_VISIBILITY
        })
    }
}

export const hideGalleryAfterDelay = (delay = 5) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            if (!delay) {
                reject('wrong delay');
            }
            dispatch({
                type: consts.TRIGGER_AUTOHIDE
            });

            setTimeout(() => {
                if (!getState().floorplan.autohideDisabled) {
                    dispatch(toggleVisibility());
                }
                resolve();
            }, delay * 1000);
        })
    }
}

export const navigateToFloorplan = (element) => {
    return (dispatch, getState) => {
        dispatch(savePosition(element));
        dispatch(push(`/${getState().app.tourId}/${getState().app.tourType.charAt(0)}/floorplan`));
    }
}
